export enum SortDirection {
    desc = 'desc',
    asc = 'asc',
}
